import { render, staticRenderFns } from "./CommissionPendingCard.vue?vue&type=template&id=df43a6bc"
import script from "./CommissionPendingCard.vue?vue&type=script&lang=js"
export * from "./CommissionPendingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports